import React from "react";
import TrackerPanel from "../../components/tracker/TrackerPanel";

const TrackerPage = () => {
  return (
    <div className="p-4 md:p-2">
      <TrackerPanel mode="page" />
    </div>
  );
};

export default TrackerPage;
